import { type Meta } from '../types/docs';

const META: Meta = {
  description: "When a customer triggers to save an edit they've created",
  name: 'asset_edit_saved',
  params: [
    {
      description: 'The asset mode the user switched to',
      name: 'edit_types',
      required: true,
      type: 'array',
      values: ['removeObject', 'crop', 'orient', 'replaceBackground'],
    },
    {
      description: 'The type of save the user performed',
      name: 'save_type',
      required: true,
      type: 'enum',
      values: ['new_version', 'new_asset'],
    },
    {
      description: 'The category of the asset',
      name: 'category',
      required: true,
      type: 'enum',
      values: ['asset_details'],
    },
    {
      description: 'The crop preset used',
      name: 'crop_preset',
      required: false,
      type: 'string',
    },
    {
      description: 'The width of the asset',
      name: 'size_width',
      required: true,
      type: 'number',
    },
    {
      description: 'The height of the asset',
      name: 'size_height',
      required: true,
      type: 'number',
    },
  ],
};

export default META;
